import useNotification from "utils/hooks/useNotification";
import useFooterStore from "views/hooks/useFooterStore";
import useCoreStore from "views/hooks/useCoreStore";
import { getFormError } from "utils/getFormError";
import { useParams } from "react-router-dom";
import useGeneralApi from "./useGeneralApi";
import { FormInstance } from "antd";
import { useEffect } from "react";
import { TFunction } from "i18next";

interface UseFeaturesFormProps {
  form: FormInstance;
  nextButton?: () => void;
  t: TFunction;
}

export const useFeaturesForm = ({ form, nextButton, t }: UseFeaturesFormProps) => {
  const { companyId } = useParams();
  const { notificationSuccessfullySaved, notificationError } = useNotification();

  const { updateCompanySetting, listInvoiceTypes, invoiceTypeOptions } = useGeneralApi();

  const setHandleOkSaveButton = useFooterStore(state => state.setHandleOkSaveButton);
  const setSaveLoading = useFooterStore(state => state.setSaveLoading);
  const setCompanySettings = useCoreStore(state => state.setCompanySettings);

  useEffect(() => {
    listInvoiceTypes();
  }, []);

  const handleFormSubmit = async (values: Record<string, any>) => {
    const defaultPriceType = values?.defaultPriceType ? "total" : "net";

    const variables = {
      input: {
        id: companyId,
        saleDocumentTypes: values?.saleDocumentTypes,
        defaultPriceType,
        availabilityTime: values?.availabilityTime,
        exportFormat: values?.exportFormat,
        clientHasAutoNumber: values?.clientHasAutoNumber,
        sendOverdueEmail: values?.sendOverdueEmail,
        analyticalType: values?.analyticalType,
        counterpartProductAllocationType: values?.counterpartProductAllocationType,
        prefixClientCounterpartCode: values?.prefixClientCounterpartCode,
        canExport: values?.canExport,
      },
    };

    const response = await updateCompanySetting({ variables });
    const errors = response?.data?.updateCompanySetting?.errors;

    setSaveLoading(false);

    if (errors?.length) {
      const fieldsData = getFormError(errors, values);
      notificationError(errors);
      form.setFields(fieldsData);
      setHandleOkSaveButton(false);
      return;
    }

    setCompanySettings(response.data?.updateCompanySetting?.companySetting as any);
    notificationSuccessfullySaved(t("Features"));
    setHandleOkSaveButton(false);
    nextButton?.();
  };

  const handleSaveClick = () => {
    form.submit();
    setSaveLoading(true);
  };

  return {
    handleFormSubmit,
    handleSaveClick,
    invoiceTypeOptions,
  };
};
